"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./../utils");
class ResponseMessage {
    constructor(event) {
        if (typeof event === "object" && event !== null) {
            if (utils_1.Utils.hasStringProperty(event, "result")) {
                this.result = event.result;
            }
            if (utils_1.Utils.hasStringProperty(event, "exceptionType")) {
                this.exceptionType = event.exceptionType;
            }
        }
        else {
            throw Error("Attempted to construct ResponseMessage event from incompatible History event. " +
                "This is probably a bug in History-replay. Please file a bug report.");
        }
    }
}
exports.ResponseMessage = ResponseMessage;
//# sourceMappingURL=responsemessage.js.map